// extracted by mini-css-extract-plugin
module.exports =  {"tabledFunnel":"D1gYbgGxf_q2_D0swiD7","table":"bqhASNuiNAyAOCPdDNVT"};